import styled from 'styled-components/macro';

export const ItemContainer = styled.div`
  padding: ${({ isKey }) => (isKey ? '15px 45px 15px 15px' : '15px 45px')};

  @media screen and (max-width: 387px) {
    padding: ${({ isKey }) => (isKey ? '15px 5px 15px 15px' : '15px 5px')};
  }
`;

export const ListRedirect = styled.div`
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 20px;
  width: fit-content;
  height: fit-content;
  padding: 5px 10px;
  color: white;
  word-break: break-all;
  opacity: 0.8;
  max-width: 20%;

  &.smallScreen {
    display: none;
    max-width: unset;
    margin-top: 15px;
    margin-left: 0px !important;
  }

  @media screen and (max-width: 1212px) {
    &.largeScreen {
      display: none;
    }
    &.smallScreen {
      display: block;
    }
  }

  ${({ color }) =>
    `
    background: ${color};
  `}

  &:hover {
    opacity: 1;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const ListChoiceRedirect = styled.div`
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  padding: 10px 15px;
  word-break: break-all;
  background: white;
  border-radius: 10px;
  border: 4px solid white;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  &:hover {
    ${({ color_L2 }) =>
      `
    background: ${color_L2};
  `}
  }
  & > div:first-child {
    flex: 1;
  }
  & > div:nth-child(2) {
    display: flex;
    align-items: center;
    max-width: 85%;

    & > div {
      display: flex;
      align-items: center;
      flex: 1;

      & .list-dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 5px;
        ${({ color }) =>
          `
    background: ${color};
  `}
      }

      & > span:nth-child(2) {
        flex: 1;
      }
    }
  }
`;

export const CardBack = styled.div`
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  padding: 8px;
  word-break: break-all;
  background: white;
  border-radius: 20px;
  border: 3px solid white;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
  margin-bottom: 15px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);

  &:hover {
    ${({ color_L2 }) =>
      `
    background: ${color_L2};
  `}
  }
  color: ${({ color }) => color};

  &:active {
    transform: scale(0.98);
  }
`;

export const ListChoiceBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;



export const Archive = styled.div`
  transition: all 0.25s ease-out;

  border-radius: 50%;
  padding: 2px;

  flex: 0 0 20px;
  height: 20px;
  cursor: pointer;

  &:hover > div {
    opacity: 0.85;
    ${({ color }) =>
      `
    background: ${color};
  `}
  }

  & > div {
    transition: all 0.25s ease-out;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background: transparent;
  }

  ${({ isInDelete, color }) =>
    isInDelete &&
    `
    & > div {
      background: ${color};
    }
  `}

  ${({ color }) =>
    `
    border: 2px solid ${color};
  `}
`;

export const ListChoiceButton = styled.div`
  display: flex;
  padding: 15px 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: white;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  align-items: center;

  & > span {
    flex: 1;
    word-break: break-all;
    display: flex;
    align-items: center;

    & > div {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: ${({ color }) => color};
      margin-right: 5px;
    }

    & > span {
      flex: 1;
      word-break: break-all;
    }
  }

  & > div {
    color: ${({ theme }) => theme};
    margin-left: 10px;
  }

  &:hover {
    ${({ color_L2 }) =>
      `
    background: ${color_L2};
  `}
  }
`;
